export default __webpack_public_path__ + "static/desk-feba697ab8602a43c83790b34c9ca88b.png";